const BREAKPOINTS = [
  { size: 'sm', value: '40rem', rawValue: 640 },
  { size: 'md', value: '48rem', rawValue: 768 },
  { size: 'lg', value: '64rem', rawValue: 1024 },
  { size: 'xl', value: '90rem', rawValue: 1440 },
  { size: '2xl', value: '100rem', rawValue: 1600 },
]

const getBreakpoint = (size, valueType = 'rawValue') => {
  const breakpointIndex = BREAKPOINTS.findIndex((e) => e.size == size)
  if (breakpointIndex) {
    return BREAKPOINTS[breakpointIndex][valueType]
  }

  return null
}

export { BREAKPOINTS, getBreakpoint }
